<script>
  import { mapActions } from 'vuex'
  import { isEmpty } from 'lodash'
  // import auth from '../../../../domain/auth/services/auth'

  export default {
    props: {
      channel: {
        type: String
      }
    },
    data () {
      return {
        user: {
          email: '',
          password: ''
        },
        loginError: '',
        isLoading: false
      }
    },
    beforeCreate () {
      /* if (auth.loggedIn()) { // O usuário está logado (localStorage cache) mas as informações não estão no store
        this.$store.dispatch('attemptLogin', {
          email: ':)',
          password: 'hacker'
        })
          .then(() => {
            this.$router.replace(this.$route.query.redirect || '/')
          })
      } */
    },
    methods: {
      ...mapActions(['attemptLogin']),
      doLogin () {
        this.$bar.start()
        const user = {...this.user}
        user.channel = this.channel
        this.isLoading = true
        this.attemptLogin({...user})
          .then((response) => {
            this.isLoading = false
            this.$bar.finish()

            if (response.somenteConsultaReboque) {
              this.$router.push({name: 'config.consulta-reboque'})
            } else if (this.$route.query.redirect && this.$route.query.redirect !== '/logout' && this.$route.query.redirect !== '/consulta-reboque') {
              this.$router.push({path: this.$route.query.redirect})
            } else {
              this.$router.push('/')
            }
          })
          .catch((response) => {
            this.isLoading = false
            this.$bar.finish()
            this.$emit('error', response)
            this.user.password = ''
          })
      }
    },
    computed: {
      isValid () {
        const user = this.user
        return !isEmpty(user.email) && !isEmpty(user.password)
      }
    },
    activated () {
      this.$refs.user.focus()
    }
  }
</script>

<template>
  <form class="form-login" v-on:submit.prevent="doLogin">
    <div class="login-input-container">
      <div class="login-logo">
        <img src="../../../../assets/auth/img/icone-user.png" alt="ícone" v-if="channel === 'colaborador'">
        <img src="../../../../assets/auth/img/icone-reboque.png" alt="ícone" v-else>
      </div>
      <div class="login-input">
        <label for="username">Username:</label>
        <input type="text" id="username" name="_username" ref="user" autofocus v-model="user.email"
               placeholder="Nome de usuário, email ou código"
               class="input-login username text-"
               required />
        <div class="clearfloat"></div>
        <label for="password">Password:</label>
        <input type="password" id="password" name="_password" v-model="user.password"
               class="input-login password"
               placeholder="Senha" required/>
      </div>
    </div>
    <div class="clearfloat"></div>
    <div class="s-i-l">
      <input type="checkbox" id="remember_me" name="_remember_me" value="on"
             class="lembrar" checked/>
      <label for="remember_me">Continuar conectado</label>
    </div>

    <button type="submit" class="btn-login" :disabled="!isValid">
      <span v-if="!isLoading">Entrar</span>
      <span v-if="isLoading">Aguarde...</span>
    </button>
  </form>
</template>

<style lang="scss" scoped>
.login-input-container {
  display: flex;
  justify-content: space-around;

  & > .login-logo {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;

    & > img {
      width: 150px;
    }
  }

  & > .login-input {
    flex: 3;
  }
}
</style>



// WEBPACK FOOTER //
// Login.vue?4efd2f70